import React, { useState } from "react";
import Dashboard from "../../layout/Dashboard/Dashboard";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import html2canvas from "html2canvas"; // Import html2canvas
import line from "../../assets/images/line.png";
import "./generatedChart.scss";
import PivotTableWithECharts from "../../components/Chart/PivotTableWithECharts";
import GeoMap from "../../components/Chart/GeoMap";
import AirGeoMap from "../../components/Chart/AirGeoMap";
import FusionGeoMap from "../../components/Chart/FusionGeoMap";
import { useCharts } from "../../hooks/useCharts";
import { usePivot } from "../../hooks/usePivot";
import { useTranslation } from "react-i18next";
import "../../i18n";
import CookieManager from "../../components/Cookies/CookieManager";
import { Label } from "recharts";

const GeneratedChart = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const {
    pivotData,
    label,
    chartName,
    chartType,
    category,
    selectedDataset,
    xKeys,
    yKey,
    selectedRiskFactor,
    riskFactors,
  } = state || {};
  const [selectedChartType, setSelectedChartType] = useState(chartType);
  const [updatedCl, setUpdatedCl] = useState([]);
  const [updatedRw, setUpdatedRw] = useState([]);
  const [updateAggName, setUpdateAggName] = useState("Count");
  const navigate = useNavigate();
  const { createAChart } = useCharts();
  const { createTheTable, updateTable } = usePivot();
  const [updatevals, setUpdateVals] = useState([]);
  const [updatedChartType, setUpdatedChartType] = useState(chartType);
  // Track fusion chart selections for saving
  const [currentFusionRiskFactor, setCurrentFusionRiskFactor] = useState(selectedRiskFactor);
  const [currentFusionDatasetId, setCurrentFusionDatasetId] = useState(selectedDataset);

  const handleChartTypeChange = (newChartType) => {
    setSelectedChartType(newChartType);
  };

  // Handle fusion chart selection changes
  const handleFusionSelectionChange = (riskFactor, datasetId) => {
    setCurrentFusionRiskFactor(riskFactor);
    setCurrentFusionDatasetId(datasetId);
  };

  const handlePivotStateChange = (
    rendererName,

    cols,
    rows,
    aggregatorName,
    vals
  ) => {
    setUpdatedCl(cols);
    setUpdatedRw(rows);
    setUpdateAggName(aggregatorName);
    setUpdateVals(vals);
    setUpdatedChartType(rendererName);
  };

  const handleSaveToDashboard = async (e) => {
    e.preventDefault();

    const chartElement = document.querySelector(".svg-container");
    const mapsElement = document.getElementById(chartName);

    if (!chartElement && !mapsElement) {
      console.error("Chart container not found");
      return;
    }
    let cavasElement;
    if (chartElement) {
      cavasElement = chartElement;
    } else if (mapsElement) {
      cavasElement = mapsElement;
    }

    try {
      const canvas = await html2canvas(cavasElement, {
        backgroundColor: null,
        useCORS: true,
      });

      const imageBase64 = canvas.toDataURL("image/png");
      let createdTable;
      if (!updatedRw.length || !updatedCl.length) {
        createdTable = await createTheTable(
          chartName,
          selectedDataset,
          xKeys ? [xKeys] : [],
          yKey ? [yKey] : []
        );
      } else {
        createdTable = await createTheTable(
          chartName,
          selectedDataset,
          updatedCl,
          updatedRw
        );
      }

      const tableId = createdTable.id;

      // Update the table to set data to null
      await updateTable(tableId, { data: [null] });

      // Add Base64 image to chartData
      const chartData = {
        pivotId: tableId,
        name: pivotData?.name,
        type: updatedChartType,
        width: "100%",
        height: "350",
        renderAt: updateAggName,
        chartConfig: {
          caption: category,
          subcaption: tableId,
          theme: updatevals[0],
          // Save fusion chart specific settings
          selectedRiskFactor: currentFusionRiskFactor || selectedRiskFactor || null,
          selectedDatasetId: currentFusionDatasetId || selectedDataset || null,
        },
        imageBase64, // Save the Base64 image
      };

      await createAChart(chartData);
      navigate("/single-dashboard");
    } catch (error) {
      console.error("Error capturing chart:", error);
    }
  };
  if (!state) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <Dashboard>
        <CookieManager />
        <h2 className="createChartHeader">{t("generatedChartHeader")}</h2>
        <p className="createChartDesc">{t("generatedChartdescription")}</p>
        <img className="separator" src={line} alt="" />
        <div>
          <h4 className="createChartHeader">Chart Name: {chartName}.</h4>
          <h4 className="createChartHeader">Selected Dataset: {label}.</h4>
          {selectedChartType === "Geographical Chart" &&
          category === "fusion" ? (
            <FusionGeoMap
              data={pivotData?.elements}
              chartName={chartName}
              selectedRiskFactor={selectedRiskFactor}
              selectedDatasetId={selectedDataset}
              riskFactors={riskFactors}
              onSelectionChange={handleFusionSelectionChange}
            />
          ) : selectedChartType === "Geographical Chart" &&
            category === "Air Pollution" ? (
            <AirGeoMap
              data={pivotData?.elements}
              chartName={chartName}
              category={category}
              label={label}
            />
          ) : selectedChartType === "Geographical Chart" &&
            category !== "Air Pollution" ? (
            <GeoMap
              data={pivotData?.elements}
              AirPollutants
              chartName={chartName}
              category={category}
              label={label}
            />
          ) : (
            <PivotTableWithECharts
              data={pivotData?.elements || []}
              initialPivotState={{
                data: pivotData?.elements || [],
                rows:
                  pivotData?.config?.report?.slice?.rows?.map(
                    (row) => row.uniqueName
                  ) || [],
                cols:
                  pivotData?.config?.report?.slice?.columns?.map(
                    (col) => col.uniqueName
                  ) || [],
                aggregatorName: updateAggName,
                rendererName: selectedChartType,
                vals: updatevals,
              }}
              onChartTypeChange={handleChartTypeChange}
              onChange={handlePivotStateChange}
            />
          )}
        </div>
        <div className="saveContainer">
          <Container>
            <Row className="justify-content-md-center">
              <Col md="auto">
                <Button
                  bsPrefix="saveToDash"
                  className="px-5 py-3 fw-bold no-border"
                  onClick={handleSaveToDashboard}
                >
                  Save to Dashboard
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      </Dashboard>
    </div>
  );
};

export default GeneratedChart;
